import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import Toolbar from '@material-ui/core/Toolbar';
import AddressList from '../../components/Customer/AddressList.jsx';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import CustomerAddressMap from '../../components/Map/CustomerAddressMap.jsx';
import AddServiceMedia from '../../components/Providers/AddServiceMedia';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import HOCSectionLoader from '../../components/HOC/HOCSectionLoader.jsx';
const styles = theme => ({
    card: {
        color: theme.palette.secondary.main
    }
});
export class AddMedia extends Component {
    constructor(props) {
        super();
    }

    render() {
        const { classes } = this.props;
        return (
            <div>
                <div className="row mb-4">
                    <div className="col-md-12">
                        <Card className={classes.card}>
                            <Toolbar>
                                <h3> Add New Service</h3>
                            </Toolbar>
                        </Card>
                    </div>
                </div>

                <div className="row">
                    <AddServiceMedia {...this.props} />
                </div>
            </div>
        );
    }
}

const composedComponent = compose(withStyles(styles));
export default composedComponent(AddMedia);



// WEBPACK FOOTER //
// ./src/views/ProviderService/AddMedia.jsx